import { render, staticRenderFns } from "./JDatePicker.vue?vue&type=template&id=72bce20e&scoped=true"
import script from "./JDatePicker.vue?vue&type=script&lang=js"
export * from "./JDatePicker.vue?vue&type=script&lang=js"
import style0 from "./JDatePicker.vue?vue&type=style&index=0&id=72bce20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bce20e",
  null
  
)

export default component.exports